import { useSearchParams } from "react-router-dom";
import { Button } from "@components/Button/Button";
import { RenderImg } from "@components/RenderIcon/RenderImg";
import ThinkingImg from "@assets/images/Thinking.svg";
import { useTranslation } from "react-i18next";
import { Wrapper, InfoWrapper, IconWrapper, ButtonWrapper } from "./component";
import { TopicStyle, DescStyle } from "./style";
import { onPostMsgToGrab } from "./functional";
import liff from "@line/liff";
import { useEffect } from "react";
import { useAuthContext } from "@providers/AuthProvider";
import { removeLS } from "@utils";
import { LS_AUTH } from "@configs";

export const AlreadyMappingPage: React.FC = () => {
  const { t, i18n } = useTranslation();
  const [queryParameters] = useSearchParams();
  const { authorizeState } = useAuthContext();

  const lang = queryParameters.get("lang");

  useEffect(() => {
    if (lang !== null)
      i18n.changeLanguage(lang, (err) => {
        if (!err) {
          localStorage.setItem("preferredLanguage", lang);
        }
      });
  }, [lang]);

  return (
    <Wrapper>
      <IconWrapper>
        <RenderImg
          src={ThinkingImg}
          alt="thinking"
          width={"50%"}
          height={"auto"}
        />
      </IconWrapper>
      <InfoWrapper>
        <TopicStyle className="text-center">
          {t("status.mapping.fail.topic")}
        </TopicStyle>
        <DescStyle className="text-center">
          {t("status.already.mapping.desc")}
        </DescStyle>
        <ButtonWrapper>
          <Button
            variant="success"
            onClick={() => {
              liff.closeWindow();
              onPostMsgToGrab({
                msg: `DATA:{"login_method": "${
                  authorizeState?.loginMethod ?? "APP"
                }"}`,
              });
              onPostMsgToGrab({
                msg: "ERROR:LINK_FAILED",
              });
              removeLS(LS_AUTH);
            }}>
            {t("button.close")}
          </Button>
          <Button
            variant="info"
            onClick={() => {
              liff.openWindow({
                url: "https://help.grab.com/merchant/th-th/22880479885209",
                external: true,
              });
              onPostMsgToGrab({
                msg: "ERROR:HELP_CENTER",
              });
            }}>
            {t("button.view_help_center")}
          </Button>
        </ButtonWrapper>
      </InfoWrapper>
    </Wrapper>
  );
};
